<template>
  <div class="loader" v-if='loading'>
    <Icon v-show='!flashing' icon="loading" style='font-size: 35px'/>
    <Icon v-show='flashing' icon="check" style='font-size: 36px;'/>
  </div>
</template>
<script>
export default {
  name:'Loader',
  data: function() {
    return {
      loading: false,
      flashing: false,
    }
  },
  methods: {
    load: function() {this.loading = true},
    flash: function() {
      this.loading = true;
      this.flashing = true;
      setTimeout(()=>{
        this.loading = false;
        this.flashing = false;
      }, 1000)
    },
    endload: function() {this.loading = false}
  },
  created: function() {
    this.$$.load = this.load.bind(this);
    this.$$.flash = this.flash.bind(this);
    this.$$.endload = this.endload.bind(this);
  }
}
</script>
<style lang='scss'>
.loader {
  padding: 0;
  height: 48px;
  width: 56px;
  text-align: center;
  line-height: 48px;
  display: block;
  background: #fafafa;
  border-radius: 3px;
  box-shadow: 0 2px 10px rgba(#36f,.3);
  svg path,
  svg rect{
    fill: #36f;
  }
}
</style>